// extracted by mini-css-extract-plugin
export default {"flex":"LayoutFlex__flex___3dNXy","left":"LayoutFlex__left___2pWFB LayoutFlex__flex___3dNXy","right":"LayoutFlex__right___1zK_7 LayoutFlex__flex___3dNXy"};